export default {
  CAR: "car", // avto
  GENERAL: "general", // general
  HOME: "home", // dom
  PERSON: "person", // oseba
  VESSEL: "vessel", // plovila
  ANIMAL: "animal", // živali
  NOT_LISTED: "notListed", // zavarovavanja ni na seznamu
}
